import { memo } from 'react';
import { Typography } from '@mui/material';

type ServiceNameFieldProps = {
  name?: string;
  isDisabled?: boolean;
};

export const ServiceNameField = memo(({ name, isDisabled }: ServiceNameFieldProps) => {
  return <Typography color={isDisabled ? 'text.disabled' : 'inherit'}>{name}</Typography>;
});
ServiceNameField.displayName = 'ServiceNameField';
